import React from 'react'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import styled from 'styled-components'

const DashboardDividerBox = styled.div`
  border-top: 1px solid #f1eded;
  border-bottom: 1px solid #f1eded;
  height: 10px;
  ${(props) => props.color && `background-color: ${props.color}`};
`

const MyFreebirdDashboardDivider = ({ color }) => {
  return <DashboardDividerBox color={color} />
}

export default withRouter(withAuth(MyFreebirdDashboardDivider))
